import { styled } from "../../styles";

export const Container = styled("div", {
  height: "100%",
  width: "100%",

  background: "$white",

  border: "1px solid $gray-40",
  borderRadius: "$3",

  marginTop: "6px",

  overflow: "hidden",

  // Hide scrollbar for Chrome, Safari and Opera
  "&::-webkit-scrollbar": {
    display: "none",
  },
  // Hide scrollbar for IE, Edge and Firefox
  msOverflowStyle: "none",
  scrollbarWidth: "none",

  variants: {
    // When the skeleton renders inside a container that already has a border
    // (e.g. the patient-page appointments panel) we drop its own border so we
    // don't get a table-within-a-table.
    bordered: {
      false: {
        border: "none",
        borderRadius: 0,
        marginTop: 0,
      },
    },
  },
});

export const MobileContainer = styled("div", {
  height: "85vh",
  overflow: "hidden",
});

export const Header = styled("div", {
  height: "82px",

  display: "flex",
  justifyContent: "space-between",

  padding: "35px 38px 20px 38px",
  borderBottom: "1px solid $gray-30",

  marginBottom: "8px",
});

export const WhiteRow = styled("div", {
  height: "42px",
  width: "100%",

  backgroundColor: "$white",

  "@sm": {
    height: "62px",
  },
});
